import { render, staticRenderFns } from "./VueAutonumeric.vue?vue&type=template&id=22420ca4&"
import script from "./VueAutonumeric.vue?vue&type=script&lang=js&"
export * from "./VueAutonumeric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports